import { render, staticRenderFns } from "./PolicyFilterItem.vue?vue&type=template&id=4b8f6faf&"
import script from "./PolicyFilterItem.vue?vue&type=script&lang=js&"
export * from "./PolicyFilterItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports